export default __webpack_public_path__ + "static/media/recruitee.252a98ad.svg";